module.exports = __webpack_public_path__ + "img/552.7990870f.jpg";